<template>
    <div>
        <error-license-lock
            :title="$t.__('pages.errors.ErrorLicenseStaff.account_not_accessible')"
            :subtitles="[
                $t.__('pages.errors.ErrorLicenseStaff.no_licence_selected'),
                $t.__('pages.errors.ErrorLicenseStaff.to_use_contact_company_admin'),
            ]"
        >
            <CompassButton
                :label="labels.buttons.back_home"
                size="large"
                @click="goToUrl('https://go.sellsy.com')"
            />
        </error-license-lock>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import ErrorLicenseLock from 'vcomponents/pages/errors/ErrorLicenseLock.vue';

export default {
    components: {
        ErrorLicenseLock,
    },
    data() {
        return {
            labels: {
                buttons: {
                    back_home: this.$l10n.__("Retour à l'accueil"),
                },
            },
        };
    },
    methods: {
        goToUrl,
    },
};
</script>
